import React, { useState } from "react";
import { Card, Row, Col, List, Button, Input, Typography } from "antd";

const { Text } = Typography;

const WhiteListedIPs = () => {
  // Example static IPs
  const [ipList, setIpList] = useState([
    "203.0.113.5",
    "198.51.100.0/24",
    "192.0.2.10",
  ]);
  const [newIp, setNewIp] = useState("");

  const handleRemoveIp = (ip) => {
    setIpList(ipList.filter((item) => item !== ip));
  };

  return (
    <Row gutter={[0, 16]}>
        

        <Col span={24}>
          <List
            bordered
            dataSource={ipList}
            renderItem={(ip) => (
              <List.Item
                actions={[
                  <Button danger size="small" onClick={() => handleRemoveIp(ip)}>
                    Remove
                  </Button>,
                ]}
              >
                {ip}
              </List.Item>
            )}
            style={{ marginBottom: "10px" }}
          />
        </Col>
      </Row>
  );
};

export default WhiteListedIPs;
